import { getOffersFromStoryblok } from '../../sortingHat/utils/formatters';

export async function getSBOfferList() {
  try {
    const SH_POC_FILE = `assets/storyblok/cache/sortingHatData.json?v=${Date.now()}`;
    const storyblokCacheResult = await fetch(SH_POC_FILE);
    const storyblokOffers = await storyblokCacheResult.json();
    const offers = getOffersFromStoryblok(storyblokOffers);
    if (offers.length === 0) throw new Error('No offers found on format');
    return offers;
  } catch (error) {
    console.error(`[LIBS][SB][GET_OFFERS]: `, error);
    return [];
  }
}
